// extracted by mini-css-extract-plugin
module.exports = {"btn":"RegisterComputer_btn__3hAKj"};